import React, { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const PostLoginLanguageSwitcher = ({ 
  className = ''
}) => {
  const { t, switchLanguage, language, syncLanguageFromUser } = useTranslation();

  // Sync language with user's preferredLanguage when component mounts
  useEffect(() => {
    syncLanguageFromUser();
  }, [syncLanguageFromUser]);

  const handleLanguageToggle = async (selectedLanguage) => {
    await switchLanguage(selectedLanguage);
  };

  return (
    <div className={`flex items-center ${className}`}>
      {/* Language toggle - rounded toggle design */}
      <div className="flex bg-transparent border border-gray-300 shadow-sm py-0" style={{ borderRadius: '20px', height: '30px' }}>
        <button
          onClick={() => handleLanguageToggle('en')}
          className={`px-4 font-medium transition-all duration-200 ${
            language === 'en'
              ? 'bg-white text-primary-blue shadow-sm' 
              : 'bg-transparent text-[#6B7280] hover:text-[#374151]'
          }`}
          style={{ borderRadius: '15px', fontSize: '14px' }}
          type="button"
        >
          {t('general.eng')}
        </button>
        <button
          onClick={() => handleLanguageToggle('ar')}
          className={`px-4 font-medium transition-all duration-200 ${
            language === 'ar'
              ? 'bg-white text-primary-blue shadow-sm' 
              : 'bg-transparent text-[#6B7280] hover:text-[#374151]'
          }`}
          style={{ borderRadius: '15px', fontSize: '14px' }}
          type="button"
        >
          {t('general.arabic')}
        </button>
      </div>
    </div>
  );
};

export default PostLoginLanguageSwitcher;
